/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, TableSortLabel, CircularProgress, TableFooter, TablePagination, TextField, Select, MenuItem, FormControl, Typography, Paper, IconButton } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import Group from './Group'
import Actions from '../../../../../fluid/Actions/ActionFactory';
import { LowPriorityRounded } from '@material-ui/icons';

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    headerStyle : {
        color : '#707070',
        backgroundColor : '#F5F5F5',
        fontSize : 11,
        border : 'none'
    }
})


class GroupTable extends Component {
    state = {
        rows_per_page : null,
        page : 0,
        options : [],
        open : false,
        loading : false,
        loadingText : "Loading...",
        search_term : "",
        noOptionsText : "Enter at least 3 characters to filter.",
        global_concept : "",
        groups : []
    }

    sortFilterHandler = (key) => {
        let group_filter = this.props.group_filter
        if (group_filter.sort_by === key) {
            group_filter.direction = group_filter.direction === 'asc' ? 'desc' : 'asc'
        } else {
            group_filter.sort_by = key
            group_filter.direction = 'asc'
        }
        this.props.update_filter(group_filter)
    }
    getFilteredGroups = () => {
        let sorted_groups = []
        Actions('http_request', {
            url : "/sainapse/irc/groups_by_global_concept",
            method : "post",
            data : {
                global_concept : this.state.global_concept,
                version : this.props.version,
                ic_name : this.props.ic_name,
                step_tag : this.props.step_tag
            }
        }).then(res => {
            console.log("filtered_groups:", res.data.result.Result)
            let sort_field = this.props.group_filter.sort_by
            let sort_direction = this.props.group_filter.direction
            let filtered_groups = res.data.result.Result
            
            // switch (sort_field) {
            //     case "Name":
            //         if (sort_direction === 'asc') {
            //             let groups = filtered_groups.sort((a,b) => {
            //                 if(a.group_name < b.group_name) { return -1; }
            //                 if(a.group_name > b.group_name) { return 1; }
            //                 return 0
            //             })
            //             sorted_groups = groups
            //         } else if (sort_direction === 'desc') {
            //             let groups = filtered_groups.sort((a,b) => {
            //                 if(a.group_name < b.group_name) { return 1; }
            //                 if(a.group_name > b.group_name) { return -1; }
            //                 return 0
            //             })
            //             sorted_groups = groups
            //         }
            //         break
            //     case "Record":
            //         if (sort_direction === 'asc') {
            //             let groups = filtered_groups.sort((a,b) => {
            //                 if(a.records.length < b.records.length) { return -1; }
            //                 if(a.records.length > b.records.length) { return 1; }
            //                 return 0
            //             })
            //             sorted_groups = groups
            //         } else if (sort_direction === 'desc') {
            //             let groups = filtered_groups.sort((a,b) => {
            //                 if(a.records.length < b.records.length) { return 1; }
            //                 if(a.records.length > b.records.length) { return -1; }
            //                 return 0
            //             })
            //             sorted_groups = groups
            //         }
            //         break
                
            //     case "Score":
            //         if (sort_direction === 'asc') {
            //             let groups = filtered_groups.sort((a,b) => {
            //                 if(a[this.props.score_field] < b[this.props.score_field]) { return -1; }
            //                 if(a[this.props.score_field] > b[this.props.score_field]) { return 1; }
            //                 return 0
            //             })
            //             sorted_groups = groups
            //         } else if (sort_direction === 'desc') {
            //             let groups = filtered_groups.sort((a,b) => {
            //                 if(a[this.props.score_field] < b[this.props.score_field]) { return 1; }
            //                 if(a[this.props.score_field] > b[this.props.score_field]) { return -1; }
            //                 return 0
            //             })
            //             sorted_groups = groups
            //         }
            //         break
            //     default :
            //         return filtered_groups
            // }

            sorted_groups = this.state.rows_per_page > 0 ? sorted_groups.slice(this.state.page * this.state.rows_per_page, this.state.page * this.state.rows_per_page + this.state.rows_per_page) : sorted_groups    
            this.setState({...this.state,groups : res.data.result.Result},()=>{console.log("filtered groups:", this.state.groups)})
            console.log("filtered--groups:", this.state.groups)
            return sorted_groups
        })    
    }

    getGroups = () => {
        let sort_field = this.props.group_filter.sort_by
        let sort_direction = this.props.group_filter.direction

        let sorted_groups = this.props.groups
        switch (sort_field) {
            case "Name":
                if (sort_direction === 'asc') {
                    let groups = this.props.groups.sort((a,b) => {
                        if(a.group_name < b.group_name) { return -1; }
                        if(a.group_name > b.group_name) { return 1; }
                        return 0
                    })
                    sorted_groups = groups
                } else if (sort_direction === 'desc') {
                    let groups = this.props.groups.sort((a,b) => {
                        if(a.group_name < b.group_name) { return 1; }
                        if(a.group_name > b.group_name) { return -1; }
                        return 0
                    })
                    sorted_groups = groups
                }
                break
            case "Record":
                if (sort_direction === 'asc') {
                    let groups = this.props.groups.sort((a,b) => {
                        if(a.records.length < b.records.length) { return -1; }
                        if(a.records.length > b.records.length) { return 1; }
                        return 0
                    })
                    sorted_groups = groups
                } else if (sort_direction === 'desc') {
                    let groups = this.props.groups.sort((a,b) => {
                        if(a.records.length < b.records.length) { return 1; }
                        if(a.records.length > b.records.length) { return -1; }
                        return 0
                    })
                    sorted_groups = groups
                }
                break
            
            case "Score":
                if (sort_direction === 'asc') {
                    let groups = this.props.groups.sort((a,b) => {
                        if(a[this.props.score_field] < b[this.props.score_field]) { return -1; }
                        if(a[this.props.score_field] > b[this.props.score_field]) { return 1; }
                        return 0
                    })
                    sorted_groups = groups
                } else if (sort_direction === 'desc') {
                    let groups = this.props.groups.sort((a,b) => {
                        if(a[this.props.score_field] < b[this.props.score_field]) { return 1; }
                        if(a[this.props.score_field] > b[this.props.score_field]) { return -1; }
                        return 0
                    })
                    sorted_groups = groups
                }
                break
            default :
                return this.props.groups
        }

        sorted_groups = this.state.rows_per_page > 0 ? sorted_groups.slice(this.state.page * this.state.rows_per_page, this.state.page * this.state.rows_per_page + this.state.rows_per_page) : sorted_groups
        //this.setState({...this.state, groups : sorted_groups})
        return sorted_groups
    }

    renderHeaderCells = (cell) => {
        const { classes } = this.props
        switch (cell) {
            case "$pin" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )
            
            case "Rank" :
                return (
                    <TableCell
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'left'
                    >Rank</TableCell>
                )
            
            case "$icon" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )
            
            case "Name" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'left'
                    >
                        <TableSortLabel
                            active = {this.props.group_filter.sort_by === 'Name'}
                            direction = {this.props.group_filter.sort_by === 'Name' ? this.props.group_filter.direction : 'asc'}
                            onClick = {() => this.sortFilterHandler('Name')}
                        >
                            Name
                        </TableSortLabel>
                    </TableCell>
                )
            
            case "Records" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    >
                        <TableSortLabel
                            active = {this.props.group_filter.sort_by === 'Record'}
                            direction = {this.props.group_filter.sort_by === 'Record' ? this.props.group_filter.direction : 'asc'}
                            onClick = {() => this.sortFilterHandler('Record')}
                        >
                            {/* {this.props.field_display_name + "s"} */}
                            Records
                        </TableSortLabel>
                    </TableCell>
                )
            
            case "Score": 
                    return (
                        <TableCell 
                            className = {classes.headerStyle}
                            padding = 'none' 
                            size = 'small'
                            align = 'center'
                        >
                            <TableSortLabel
                                active = {this.props.group_filter.sort_by === 'Score'}
                                direction = {this.props.group_filter.sort_by === 'Score' ? this.props.group_filter.direction : 'asc'}
                                onClick = {() => this.sortFilterHandler('Score')}
                            >
                                Score
                            </TableSortLabel>
                        </TableCell>
                    )
                
            case "$options" :
                return (
                    <TableCell 
                        style = {{
                            color : '#707070',
                            backgroundColor : '#F5F5F5',
                            fontSize : 12,
                            border : 'none'
                        }}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )

            default :
                return null
        }
    }

    renderHead = () => {
        console.log('IRC : Rendering Columns : ', this.props.columns)
        return (
            <TableRow style = {{width : '90%'}}>
                {this.props.columns.map(column => {
                    console.log('IRC :: Rendering Column : ', column)
                    return this.renderHeaderCells(column)
                })}
            </TableRow>
        )
    }

    renderBody = () => {
        console.log("global_concept", this.state.global_concept)
        return (
            <TableBody>
                {this.state.global_concept===""?this.renderRows(this.getGroups()):this.renderRows(this.state.groups)}
            </TableBody>
        )
    }

    isPinned = (group_object) => {
        if (this.props.pinned_groups.length === 0) {
            return false
        }

        let group_id = group_object.group_id
        let pin_idx = this.props.pinned_groups.findIndex(pinned_group_id => pinned_group_id === group_id)

        if (pin_idx !== -1) {
            return true
        } else {
            return false
        }
    }

    renderRows = (groups) => {
        console.log("rendering groups :: ", groups)
        let rows = groups.map(group => {
            return (
                <Group
                    group_display_name = {this.props.group_display_name}
                    field_display_name = {this.props.field_display_name}
                    key = {group.name}
                    score_field = {this.props.score_field}
                    group_data = {group} 
                    columns = {this.props.columns}
                    pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                    is_pinned = {this.isPinned(group)}
                    focus_group = {(group_object) => this.props.focus_group(group_object)}
                    delete_group = {(group_data) => this.props.delete_group(group_data)}
                    highlight_name = {this.props.highlight_name}
                />
            )
        })

        return rows
    }

    onChangeHandle = (value) => {
        this.setState({...this.state, search_term : value}, () => {
            if (this.state.search_term.length > 2) {
                this.setState({...this.state, loading : true, loadingText: "Loading..."}, () => this.search())
            } else {
                this.setState({...this.state, loading : false, options : [], loadingText: "Enter at least 3 characters to filter.", noOptionsText : "Enter at least 3 characters to filter."})
            }
        })
    }

    search = () => {
        Actions('http_request', {
            url : "/sainapse/irc/search",
            method : "post",
            data : {
                ic_name : this.props.ic_name,
                version : this.props.version,
                key : this.state.search_term,
                step_tag : this.props.step_tag
            }
        }).then(res => {
            let options = res.data.result.Result.groups
            this.setState({...this.state, loading : false, loadingText : "", options : options, noOptionsText : options.length === 0 ? "No Results..." : "Enter at least 3 characters to filter."})
        })
    }

    render() { 
        //let from = 2, to = 10, count = 10
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{
                    marginTop : this.props.top_margin,
                    width : '100%'
                }}>
                    {/* {this.props.show_search && 
                    <Autocomplete
                        onOpen={() => {
                            this.setState({...this.state, open : true});
                        }}
                        onClose={() => {
                            this.setState({...this.state, open : false, loading : false, noOptionsText : "Enter at least 3 characters to filter.", options: []});
                        }}
                        open = {this.state.open}
                        loading = {this.state.loading}
                        options = {this.state.options}
                        openOnFocus = {true}
                        getOptionLabel = {(option) => option.group_name}
                        noOptionsText = {this.state.noOptionsText}
                        renderInput={(params) => <TextField 
                            {...params}
                            style = {{margin : '5px', width : '23vw'}} 
                            label={this.props.search_label} 
                            variant="outlined" 
                            size = 'small'
                            onChange={ev => this.onChangeHandle(ev.target.value)}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {this.state.loading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                )
                              }}
                        />}
                        renderOption = {(group) => {
                            return (
                                    <Group
                                        group_display_name = {this.props.group_display_name}
                                        field_display_name = {this.props.field_display_name}
                                        key = {group.name}
                                        score_field = {this.props.score_field}
                                        group_data = {group} 
                                        columns = {["$pin", "$icon", "Name"]}
                                        pin_group = {(group_id, action) => this.props.pin_group(group_id, action)}
                                        is_pinned = {this.isPinned(group)}
                                        focus_group = {(group_object) => {
                                            let group = this.props.groups.find(group => group.group_id === group_object.group_id)
                                            this.props.focus_group(group)
                                        }}
                                        delete_group = {(group_data) => this.props.delete_group(group_data)}
                                        highlight_name = {this.props.highlight_name}
                                    />
                            )
                        }}
                    />} */}
                    {/* {this.props.show_search && <Paper
                        square 
                        variant = 'outlined' 
                        style = {{
                            width : '100%',
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            padding : '10px'
                        }}
                    >
                    <Typography style = {{margin : 0, padding : 0}} variant = 'subtitle2' color = 'textPrimary'>Filter by global concept: </Typography>
                    <FormControl
                        hiddenLabel
                        size = 'small'
                        margin = "dense"
                        style = {{
                            flexGrow : 1,
                            marginLeft : '15px',
                        }}>
                            <Autocomplete
                                size='small'
                                options={this.props.global_fields}
                                getOptionLabel = {(option)=>option.global_concept}
                                renderInput={(params) => <TextField {...params} label={this.props.global_field_display_name} />}
                                onChange = {(event,newValue) => this.setState({...this.state, global_concept : newValue?newValue.global_concept:""}, () => {
                                    this.getFilteredGroups()
                                })}
                            />
                        </FormControl>
                    </Paper>} */}
                    
                    
                    <TableContainer style = {{maxHeight : (this.props.body_height - 50) + "px"}}>
                        {/* <TablePagination
                            style = {{width : '100%', margin : 0, padding : 0}}
                            rowsPerPageOptions={[5, 10, 15, 20]}
                            colSpan={4}
                            count = {this.props.groups.length}
                            rowsPerPage={this.state.rows_per_page}
                            page = {this.state.page}
                            onPageChange={(event, newPage) => this.setState({...this.state, page : newPage})}
                            onRowsPerPageChange={(event) => this.setState({...this.state, rows_per_page: parseInt(event.target.value, 10)})}
                            SelectProps={{
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true,
                            }}
                        /> */}
                        <Table
                            style = {{
                                borderCollapse : 'separate',
                                borderSpacing : '0px 7px',
                                width : '100%'
                            }}
                            stickyHeader
                        >
                            <TableHead>
                                {this.renderHead()}
                            </TableHead>
                            {this.renderBody()}
                        </Table>
                    </TableContainer>
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(GroupTable);